import { Popconfirm } from "antd";
import styled from "styled-components";
import { createGlobalStyle } from "styled-components";

const PopoverGlobalStyles = createGlobalStyle`
    .custom-confirm-ant.unstyle-padding {
       .ant-popover-inner{
       padding:0;
      }
    }
    .bordered{
      .ant-popover-inner{
        border: 3px solid #518bb4;
       }
      
       .ant-popover-arrow{
        &::before{
        background:#518bb4;
       }
      }
    }
    .ant-popconfirm-buttons{
      .ant-btn{
          font-size: 14px;
          font-weight: 500;
      }
      .ant-btn-default.ant-btn-color-default{
        background: var(--white);
        border-color: var(--grey-color-dark);
        box-shadow: none !important;
        color: var(--text-black);
        border-width:1px;
        &:hover{
          background: var(--white);
          color:var(--btn-primary-border);
          border-color: var(--btn-primary-border);
        }
      }
    }
    
`;

export const StyledPopover = styled(Popconfirm)`
  ${PopoverGlobalStyles}
`;
